import { Component, Input } from '@angular/core';

@Component({
  selector: 'inner-loader',
  templateUrl: './inner-loader.component.html',
  styleUrls: []
})
export class InnerLoader {

    isLoading: boolean;

    @Input()
    set isActive(condition: boolean) {
        setTimeout(() => this.isLoading = condition, 100);
    }
}